(function () {
  function siteHeaderOffsetPx() {
    var custom = document.querySelector('.custom-header');
    if (!custom) return 0;
    var h = custom.getBoundingClientRect().height;
    return h > 0 ? Math.round(h) : 0;
  }

  function applySiteHeaderOffset(root) {
    var px = siteHeaderOffsetPx();
    root.style.setProperty('--ambassador-site-header-offset', px ? px + 'px' : '0px');
  }

  function initAmbassadorPage(root) {
    if (!root || root.dataset.ambassadorPageInit === 'true') return;
    root.dataset.ambassadorPageInit = 'true';

    applySiteHeaderOffset(root);
    window.addEventListener(
      'resize',
      function () {
        applySiteHeaderOffset(root);
      },
      { passive: true }
    );

    var tabs = root.querySelectorAll('.kit-tab');
    var panels = root.querySelectorAll('.kit-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = 'kit-' + tab.dataset.panel;
        tabs.forEach(function (btn) {
          btn.classList.remove('active');
        });
        tab.classList.add('active');
        panels.forEach(function (panel) {
          panel.classList.toggle('active', panel.id === panelId);
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ambassador-page]').forEach(initAmbassadorPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
